export default class NotificationService {
    /* @ngInject */
    constructor($q, $timeout, arrayUtil, navigationService) {
        this.$q = $q;
        this.$timeout = $timeout;
        this.arrayUtil = arrayUtil;

        this.notifications = [];

        navigationService.onSuccess(this.onStateChange.bind(this));
    }

    show(options, closeOnStateChange, closeTimeout) {
        options = options || {};

        closeOnStateChange = !!closeOnStateChange;
        closeTimeout = closeTimeout == null ? 5000 : closeTimeout;

        let notification = this.arrayUtil.find(this.notifications, (notification) => notification.id === options.id);

        return notification
            ? this.update(notification, options, closeOnStateChange, closeTimeout)
            : this.create(options, closeOnStateChange, closeTimeout);
    }

    showInfo(message, title, ...args) {
        return this.show({
            component: 'dbATextNotification',
            id: 'ui-info',
            bindings: {
                title: title || `All good!`,
                message
            }
        }, ...args);
    }

    showError(message, title, ...args) {
        return this.show({
            component: 'dbAErrorNotification',
            id: 'ui-error',
            bindings: {
                title: title || `Something Went Wrong`,
                message
            }
        }, ...args);
    }

    create(notification, closeOnStateChange, closeTimeout) {
        notification = notification || {};
        notification.bindings = notification.bindings || {};
        notification.closeOnStateChange = !!closeOnStateChange;
        notification.closeTimeout = closeTimeout;

        notification.promise = this.$q((resolve, reject) => {
            notification.close = reject;
            notification.bindings.onClose = notification.close;

            this.scheduleClose(notification);
        }).finally(() => {
            let index = this.notifications.indexOf(notification);
            if (index >= 0) {
                this.$timeout.cancel(notification.timeout);
                this.notifications.splice(index, 1);
            }
        }).catch(() => null);

        this.notifications.unshift(notification);
        
        return notification.promise;
    }

    update(notification, options, closeOnStateChange, closeTimeout) {
        notification.closeOnStateChange = !!closeOnStateChange;
        notification.closeTimeout = closeTimeout;
        notification.bindings = options.bindings || {};

        this.scheduleClose(notification);

        return notification.promise;
    }

    scheduleClose(notification) {
        if (notification.closeTimeout > 0) {
            this.$timeout.cancel(notification.timeout);
            notification.timeout = this.$timeout(() => notification.close(), notification.closeTimeout);
        }
    }

    onStateChange() {
        this.notifications.forEach((notification) => {
            if (notification.closeOnStateChange) {
                notification.close();
            }
        });
    }

    disableClose() {
        this.notifications.forEach((notification) => this.$timeout.cancel(notification.timeout));
    }

    enableClose() {
        this.notifications.forEach(this.scheduleClose.bind(this));
    }
}



// WEBPACK FOOTER //
// ./src/application/service/notification.service.js